import * as React from 'react';
import { StyledMobileSeparator, StyledSeparator } from './NavbarSeparator.style';

const MobileNavbarSeparator = (): React.ReactElement<any> => <StyledMobileSeparator />;

const NavbarSeparator = (): React.ReactElement<any> => <StyledSeparator />;

NavbarSeparator.Mobile = MobileNavbarSeparator;
export default NavbarSeparator;
